import { render, staticRenderFns } from "./BaseVideo.vue?vue&type=template&id=168490a0&scoped=true&"
import script from "./BaseVideo.vue?vue&type=script&lang=ts&"
export * from "./BaseVideo.vue?vue&type=script&lang=ts&"
import style0 from "./BaseVideo.vue?vue&type=style&index=0&id=168490a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168490a0",
  null
  
)

export default component.exports